/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit, AfterViewInit, AfterViewChecked } from '@angular/core';


@Component({
  selector: 'ngx-auth-header',
  template: `  <ngx-layout-direction-switcher style="display:flex;"  class="direction-switcher"></ngx-layout-direction-switcher>

`,
  styleUrls: [],
})

export class AuthHeaderComponent  {

  }







